"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLatestActivity = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any */
const react_query_1 = require("react-query");
const ObjectivesClient_1 = require("src/client/ObjectivesClient");
const latestActivity_1 = __importDefault(require("src/consts/queryKeys/latestActivity"));
const useLatestActivity = (id, options) => {
    const fetch = () => {
        return (0, ObjectivesClient_1.getObjectiveLastActivity)(id);
    };
    return (0, react_query_1.useQuery)(latestActivity_1.default.latestActivity(id), fetch, options);
};
exports.useLatestActivity = useLatestActivity;
